import { Component, h, Prop, Event, EventEmitter } from '@stencil/core';

@Component({
  tag: 'signet-progress-step',
  styleUrl: 'signet-progress.scss',
})
export class SignetProgressStep {
  @Prop() label: string;
  @Prop() complete = false;
  @Prop() inProgress = false;
  @Prop() invalid = false;
  @Prop() disabled = false;

  @Event() stepClicked: EventEmitter<void>;

  handleClick() {
    if (!this.disabled) {
      this.stepClicked.emit();
    }
  }

  render() {
    return (
      <div
        class={{
          'signet-progress-step': true,
          complete: this.complete,
          invalid: this.invalid,
          disabled: this.disabled,
          'in-progress': this.inProgress,
        }}
        onClick={() => this.handleClick()}
      >
        {this.complete && (
          <signet-icon icon="check_circle" class="complete-icon" />
        )}
        <div class="label">{this.label}</div>
      </div>
    );
  }
}
